import moment from 'moment';
import util from '@core/services/util';

export default class ApplicationsEmployment {
	constructor(init) {
		this.employerName = null;
		this.phone = null;
		this.position = null;
		this.supervisorFirstName = null;
		this.supervisorLastName = null;
		this.supervisorPhone = null;
		this.startDate = null;
		this.payType = null; // Possible Values: hourly, salary
		this.payAmount = null;
		this.getPaidOvertime = null;
		this.weeklyHours = null;
		this.commissionsAndBonusesAmount = null;
		this.commissionsAndBonusesFrequency = null; // Possible Values: weekly, bi-weekly, monthly, annually
		this.commissionsAndBonusesDescription = null;

		if (init) {
			this.employerName = init.employerName;
			this.phone = init.phone;
			this.position = init.position;
			this.supervisorFirstName = init.supervisorFirstName;
			this.supervisorLastName = init.supervisorLastName;
			this.supervisorPhone = init.supervisorPhone;
			this.startDate = init.startDate ? moment(init.startDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]').format('YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]') : init.startDate;
			this.payType = init.payType;
			this.payAmount = init.payAmount;
			this.getPaidOvertime = init.getPaidOvertime;
			this.weeklyHours = init.weeklyHours;
			this.commissionsAndBonusesAmount = init.commissionsAndBonusesAmount;
			this.commissionsAndBonusesFrequency = init.commissionsAndBonusesFrequency;
			this.commissionsAndBonusesDescription = init.commissionsAndBonusesDescription;
		}
	}

	getEmployerPhoneNumberFormatted() {
		let phone = util.formatPhoneNumber(this.phone);
		return phone;
	}

	getEmployerNameProper() {
		return util.toProperCase(this.employerName);
	}
}
